<template>
  <div>
    <v-dialog
      persistent
      v-model="showNewOnvifDiscoveryVersionDialog"
      width="40vw"
    >
      <v-card :loading="loading">
        <v-form
          lazy-validation
          v-model="form"
          ref="newOnvifDiscoveryVersionForm"
          :disable="loading"
        >
          <v-card-title>
            <span class="text-h6">New Onvif Discovery Version</span>
            <v-spacer></v-spacer>
            <v-btn @click="close" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="onvifDiscoveryVersionPayload.version"
                  :rules="[rules.required]"
                  color="deep-purple"
                  label="*Version"
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pr-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn
              @click="newOnvifDiscoveryVersion()"
              :disabled="!form || loading"
              color="primary"
            >
              SAVE
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'

export default {
  props: {
    showNewOnvifDiscoveryVersionDialog: { type: Boolean, default: false }
  },

  data: () => ({
    loading: false,
    form: true,
    onvifDiscoveryVersionPayload: {
      version: ''
    },
    rules: {
      required: (value) => !!value || 'Required.'
    }
  }),

  methods: {
    newOnvifDiscoveryVersion () {
      if (this.$refs.newOnvifDiscoveryVersionForm.validate()) {
        this.loading = true
        apiService
          .post(
            'admin/onvif_discovery_version',
            this.onvifDiscoveryVersionPayload
          )
          .then((res) => {
            this.loading = false
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'New onvif discovery version added successfully'
            })
            this.$emit('fetchOnvifDiscoveryVersion')
            this.$store.dispatch(
              'setNonNotifiedOnvifDiscoveryVersion',
              res.data.new_version.id
            )
            this.close()
          })
          .catch((err) => {
            this.loading = false
            Swal.fire({
              icon: 'error',
              title: 'Failed to add onvif discovery version',
              text: err.response.data.message
            })
          })
      }
    },
    close () {
      this.$emit('closeNewOnvifDiscoveryVersionDialog')
    }
  }
}
</script>

  <style>
</style>
